import { render, staticRenderFns } from "./ForwardIpHeader.vue?vue&type=template&id=63cf02e2"
import script from "./ForwardIpHeader.vue?vue&type=script&lang=js"
export * from "./ForwardIpHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports